/* eslint-disable jsx-a11y/anchor-is-valid */
import './style.scss'

import React, {useEffect, useState} from 'react'
import {Button, Col, Form, Modal, Row} from 'react-bootstrap-v5'
import {useTranslation} from 'react-i18next'

import { useAppSelector } from 'setup/redux/Hooks'
import {
  SideMenuStatus,
  TicketStatus,
  TicketStatusClass,
  TicketStatusLabel,
} from 'app/utils/common/constants'
import {TicketSource, TicketType} from 'app/utils/common/enum'
import MapMaker from 'app/utils/helpers/components/MapMaker'
import { formatShortCustomerId } from 'app/utils/helpers'
import { TagsModel, TicketModel } from '../../models'
import {
  selectCustomerTagsData,
  selectLoadingTimeLineTicket,
  selectTicketFlagData,
  selectTicketSubscriptionData,
  selectTicketTimeLineData,
  ticketActions,
} from '../../redux/TicketSlice'
import { InvoiceDetail } from './components/InvoiceDetail'
import { TicketTimeLine } from './components/TicketTimeLine'
import { MajorServiceModel } from 'app/utils/common/models'
import { selectMenuConfig, selectServiceScope } from 'app/modules/auth'
import moment from 'moment'
import TicketDetailSkeleton from './skeletons/TicketDetailSkeleton'
import { Dropdown } from 'react-bootstrap'
import { classNameFunc } from 'app/utils/helpers/components/Form'
import { mapStatus } from '../../attendance-delivery/AttendanceDelivery'
import { useDispatch } from 'react-redux'
import { AttendanceDeliveryActionRequest, IStatusAttendanceDelivery } from '../../models/TicketAttendanceDelivery'
import { ToastDefaultConfig } from 'setup/toast/ToastConfig'
import { toast } from 'react-toastify';
import { ticketApi } from '../../redux/TicketApi'
import { HTTP_RESPONSE_STATUS } from 'setup/constants/Http'
import { syncTicketStatusById } from 'app/modules/trip/redux/TripSlice'

type Props = {
  className?: string
  data: TicketModel | null
  isShow?: boolean
  onHide?: () => void
  onDispute?: (data: string) => void
  onComplete?: (data: TicketModel) => void
  onReassign?: (data: TicketModel) => void
  rtl?: boolean
  onWarranty?: (data: TicketModel) => void
  spAdminId?: string,
}

const ViewTicketModal: React.FC<Props> = ({
  className,
  data,
  isShow,
  rtl,
  onHide,
  onDispute,
  onComplete,
  onReassign,
  onWarranty,
  spAdminId
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation()
  const menuConfig = useAppSelector(selectMenuConfig)
  const flagData = useAppSelector(selectTicketFlagData)

  const timeLineData = useAppSelector(selectTicketTimeLineData)
  const [majorServices, setMajorService] = useState<MajorServiceModel | null>(null)
  const serviceScope = useAppSelector(selectServiceScope)
  const [flags, setFlags] = useState<TicketModel[]>([])
  const isLoading = useAppSelector(selectLoadingTimeLineTicket)
  const [isLoadingUpdateAttendanceDelivery, setIsLoadingUpdateAttendanceDelivery] = useState(false)
  const [isDisputedTicket, setIsDisptedTicket] = useState(false)
  const dataCustomerTags = useAppSelector(selectCustomerTagsData)
  const [dataComments, setDataComments] = useState('');

  const ticketSubscriptionData = useAppSelector(selectTicketSubscriptionData);
  const [statusAttendanceDelivery, setAttendanceDelivery] = useState<IStatusAttendanceDelivery>();
  const [isStatusCancel, setIsStatusCancel] = useState(false);
  
  useEffect(() => {
    if (data && data?.majorId) {
      setMajorService(serviceScope?.majorServices?.find((x) => x.id === data.majorId) || 
        serviceScope?.b8akMajorService?.find((x) => x.id === data.majorId) || 
        null)
    }
    if (data) {
      setFlags(flagData.data.filter((x) => x.id === data.id))
      
      let isDisputed = false;
      if(data.status.includes("Disputed")){
        isDisputed = true;
      }
      setIsDisptedTicket(isDisputed);
    }
    setDataComments(data?.customerComments || '');
  }, [data])

  useEffect(() => {
    if (timeLineData.length > 0 && data) {
      const isCancelB8 = timeLineData.find(item => item.ticketStatus?.startsWith(TicketStatus.Canceled) === true) ? true : false; 
      const statusCancel = (data.statusLabel.startsWith(TicketStatus.Canceled));
      setIsStatusCancel(statusCancel && isCancelB8);
    }
  }, [timeLineData])

  useEffect(() => {
    if (ticketSubscriptionData.length > 0) {
      const tmpStatusAttendanceDelivery = mapStatus.find((event) => event.statusMap.findIndex((e) =>
        typeof e === 'string'
          ? e === ticketSubscriptionData[ticketSubscriptionData.length - 1].newTicketStatus && event.type !== 'attendance'
          : e.rule === 'startsWith'
            ? ticketSubscriptionData[ticketSubscriptionData.length - 1].newTicketStatus.startsWith(e.status)
            : e.event === ticketSubscriptionData[ticketSubscriptionData.length - 1].eventName && e.status === ticketSubscriptionData[ticketSubscriptionData.length - 1].newTicketStatus
      ) >= 0)
      setAttendanceDelivery(tmpStatusAttendanceDelivery?.status);
      return
    }
    setAttendanceDelivery(undefined);
  }, [ticketSubscriptionData])

  useEffect(() => {
    console.log('attendance status', statusAttendanceDelivery)
  }, [statusAttendanceDelivery])

  if (!isShow || !data) return <></>

  const handleViewInvoice = () => {
    window.open(`${process.env.REACT_APP_INVOICE_URL}?ticket=${data.id}`, '_blank')
  }
  const attendanceDelivery: {
    isShow: boolean, isShowUndo: boolean, isActive: boolean,
    statusSelected?: IStatusAttendanceDelivery,
  } = {
    isShow: data.ticketType === TicketType.SUBSCRIPTION && !isStatusCancel,
    isShowUndo: false,
    isActive: !(!statusAttendanceDelivery),
    statusSelected: statusAttendanceDelivery,
  }
  const onChangeStatusAttendanceDelivery = async (type: 'attendance' | 'delivery', item: any, status: string) => {
    if (status === attendanceDelivery.statusSelected) {
        return;
    }
    setIsLoadingUpdateAttendanceDelivery(true);
    const updateStatus = mapStatus.find(e => e.status === status)?.update || '';
    const paramAttendanceDelivery: AttendanceDeliveryActionRequest = {
      ticketId: data.id,
      spId: data.spId,
      workerIds: data.workerId,
      status: updateStatus,
      spAdminId: spAdminId || '',
    }

    const resp = await ticketApi.updateStatusTicketSubscription(paramAttendanceDelivery).catch((e) => ({status: -1, message: e}))
    if(resp.status !== HTTP_RESPONSE_STATUS.SUCCESS){
      toast.error((resp as any).message, ToastDefaultConfig())
      setIsLoadingUpdateAttendanceDelivery(false);
      return;
    }
    
    setIsLoadingUpdateAttendanceDelivery(false);
    if (updateStatus === TicketStatus.Ticket_Declined || updateStatus === TicketStatus.InprogressConfirmed) {
      const tmpData = {...data};
      tmpData.statusLabel = TicketStatus.Inprogress;
      tmpData.status = updateStatus;
      dispatch(ticketActions.updateTicketDataModal(tmpData));
    }

    else if (updateStatus === TicketStatus.Delivered) {
      const tmpData = {...data};
      tmpData.scheduledVisitDateTime = new Date();
      tmpData.scheduledVisitDateTime.setHours(new Date(data.scheduledVisitDateTime).getHours());
      tmpData.scheduledVisitDateTime.setMinutes(new Date(data.scheduledVisitDateTime).getMinutes());
      tmpData.statusLabel = TicketStatus.Inprogress;
      tmpData.status = updateStatus;
      dispatch(ticketActions.updateTicketDataModal(tmpData));
    }

    else if (updateStatus.startsWith(TicketStatus.Undelivered)) {
      const tmpData = {...data};
      tmpData.statusLabel = TicketStatus.Canceled;
      tmpData.status = updateStatus;
      dispatch(ticketActions.updateTicketDataModal(tmpData));
    }

    // Reflect the new status in the Trip list ("Ticket Status" column) and the
    // Manual Routing modal ("Status" column), which both read from the trip store.
    // "Ticket_Declined" isn't a display status in the trip views, so surface it as
    // In-Progress (matching how the package modal handles an unattendant worker).
    const tripSyncStatus =
      updateStatus === TicketStatus.Ticket_Declined ? TicketStatus.Inprogress : updateStatus
    dispatch(syncTicketStatusById({ticketId: data.id, status: tripSyncStatus}));

    dispatch(ticketActions.getTicketSubscription({ticketId: data.id}));
    // dispatch(ticketActions.setOpeningViewOrderModal(data));
    dispatch(ticketActions.getTimeLineInOrderModal(data));
    dispatch(ticketActions.getCustomerTags({customer_id: data.customerId}));
  }

  return (
    <>
      <Modal
        show={isShow}
        onHide={onHide}
        backdrop='static'
        keyboard={false}
        size='xl'
        className={className}
      >
        <Modal.Header closeButton className='header-primary'>
          <Modal.Title className='fw-normal'>{t('VIEW_TICKET_MODAL.TITLE')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {flags.length > 0 &&
            flags.map((flag, index) => (
              <div className={'alert px-10 py-3 ' + flag.flagLevel} key={index}>
                <strong>{rtl ? flag.flagDescriptionAr : flag.flagDescription}</strong>
              </div>
            ))}
          {isLoading ? (
            <TicketDetailSkeleton />
          ) : (
            <Row>
              <Col sm={12} lg={8} className='mb-5'>
                <Row>
                  {/* Ticket */}
                  <Col sm={12} xl={5} className='mb-5'>
                    <div className='border rounded p-5 h-400'>
                      <div className='mb-3 d-flex justify-content-between'>
                        <div className='d-flex'>
                          <h4>{t('VIEW_TICKET_MODAL.TICKET')}</h4>
                          <b className='m-0'> (#{data.id.substring(0, 8)})</b>
                        </div>
                        <div className={`badge ${TicketStatusClass[data.statusLabel]}`}>
                          {(
                            TicketStatusLabel[data.status] 
                              ? t(TicketStatusLabel[data.status]) 
                              : t(TicketStatusLabel[data.statusLabel])
                          )}
                        </div>
                      </div>

                      <ul className='list-group list-group-flush'>
                        <li className='list-group-item d-flex px-0 py-3'>
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='16'
                            height='16'
                            fill='currentColor'
                            className='bi bi-wrench-adjustable w-40px'
                            viewBox='0 0 16 16'
                          >
                            <path d='M16 4.5a4.492 4.492 0 0 1-1.703 3.526L13 5l2.959-1.11c.027.2.041.403.041.61Z' />
                            <path d='M11.5 9c.653 0 1.273-.139 1.833-.39L12 5.5 11 3l3.826-1.53A4.5 4.5 0 0 0 7.29 6.092l-6.116 5.096a2.583 2.583 0 1 0 3.638 3.638L9.908 8.71A4.49 4.49 0 0 0 11.5 9Zm-1.292-4.361-.596.893.809-.27a.25.25 0 0 1 .287.377l-.596.893.809-.27.158.475-1.5.5a.25.25 0 0 1-.287-.376l.596-.893-.809.27a.25.25 0 0 1-.287-.377l.596-.893-.809.27-.158-.475 1.5-.5a.25.25 0 0 1 .287.376ZM3 14a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z' />
                          </svg>
                          <div className='w-100-40px'>
                            {rtl ? majorServices?.nameAr : majorServices?.nameEn}
                          </div>
                        </li>
                        <li className='list-group-item d-flex px-0 py-3'>
                          <svg
                            width='15'
                            height='15'
                            viewBox='0 0 15 15'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                            className='w-40px'
                          >
                            <path
                              d='M7.5 12.2727C7.64834 12.2727 7.79334 12.2327 7.91668 12.1578C8.04002 12.0829 8.13614 11.9764 8.19291 11.8518C8.24968 11.7272 8.26453 11.5902 8.23559 11.4579C8.20665 11.3256 8.13522 11.2041 8.03033 11.1088C7.92544 11.0134 7.7918 10.9485 7.64632 10.9222C7.50083 10.8959 7.35003 10.9094 7.21299 10.961C7.07594 11.0126 6.95881 11.1 6.8764 11.2121C6.79399 11.3242 6.75 11.4561 6.75 11.5909C6.75 11.7717 6.82902 11.9452 6.96967 12.073C7.11032 12.2009 7.30109 12.2727 7.5 12.2727ZM11.25 12.2727C11.3983 12.2727 11.5433 12.2327 11.6667 12.1578C11.79 12.0829 11.8861 11.9764 11.9429 11.8518C11.9997 11.7272 12.0145 11.5902 11.9856 11.4579C11.9566 11.3256 11.8852 11.2041 11.7803 11.1088C11.6754 11.0134 11.5418 10.9485 11.3963 10.9222C11.2508 10.8959 11.1 10.9094 10.963 10.961C10.8259 11.0126 10.7088 11.1 10.6264 11.2121C10.544 11.3242 10.5 11.4561 10.5 11.5909C10.5 11.7717 10.579 11.9452 10.7197 12.073C10.8603 12.2009 11.0511 12.2727 11.25 12.2727ZM11.25 9.54545C11.3983 9.54545 11.5433 9.50547 11.6667 9.43055C11.79 9.35563 11.8861 9.24914 11.9429 9.12456C11.9997 8.99997 12.0145 8.86288 11.9856 8.73062C11.9566 8.59836 11.8852 8.47687 11.7803 8.38152C11.6754 8.28616 11.5418 8.22123 11.3963 8.19492C11.2508 8.16861 11.1 8.18211 10.963 8.23372C10.8259 8.28532 10.7088 8.37271 10.6264 8.48484C10.544 8.59696 10.5 8.72879 10.5 8.86364C10.5 9.04447 10.579 9.21789 10.7197 9.34575C10.8603 9.47362 11.0511 9.54545 11.25 9.54545ZM7.5 9.54545C7.64834 9.54545 7.79334 9.50547 7.91668 9.43055C8.04002 9.35563 8.13614 9.24914 8.19291 9.12456C8.24968 8.99997 8.26453 8.86288 8.23559 8.73062C8.20665 8.59836 8.13522 8.47687 8.03033 8.38152C7.92544 8.28616 7.7918 8.22123 7.64632 8.19492C7.50083 8.16861 7.35003 8.18211 7.21299 8.23372C7.07594 8.28532 6.95881 8.37271 6.8764 8.48484C6.79399 8.59696 6.75 8.72879 6.75 8.86364C6.75 9.04447 6.82902 9.21789 6.96967 9.34575C7.11032 9.47362 7.30109 9.54545 7.5 9.54545ZM12.75 1.36364H12V0.681818C12 0.500989 11.921 0.327566 11.7803 0.1997C11.6397 0.0718342 11.4489 0 11.25 0C11.0511 0 10.8603 0.0718342 10.7197 0.1997C10.579 0.327566 10.5 0.500989 10.5 0.681818V1.36364H4.5V0.681818C4.5 0.500989 4.42098 0.327566 4.28033 0.1997C4.13968 0.0718342 3.94891 0 3.75 0C3.55109 0 3.36032 0.0718342 3.21967 0.1997C3.07902 0.327566 3 0.500989 3 0.681818V1.36364H2.25C1.65326 1.36364 1.08097 1.57914 0.65901 1.96274C0.237053 2.34633 0 2.8666 0 3.40909V12.9545C0 13.497 0.237053 14.0173 0.65901 14.4009C1.08097 14.7845 1.65326 15 2.25 15H12.75C13.3467 15 13.919 14.7845 14.341 14.4009C14.7629 14.0173 15 13.497 15 12.9545V3.40909C15 2.8666 14.7629 2.34633 14.341 1.96274C13.919 1.57914 13.3467 1.36364 12.75 1.36364ZM13.5 12.9545C13.5 13.1354 13.421 13.3088 13.2803 13.4367C13.1397 13.5645 12.9489 13.6364 12.75 13.6364H2.25C2.05109 13.6364 1.86032 13.5645 1.71967 13.4367C1.57902 13.3088 1.5 13.1354 1.5 12.9545V6.81818H13.5V12.9545ZM13.5 5.45455H1.5V3.40909C1.5 3.22826 1.57902 3.05484 1.71967 2.92697C1.86032 2.79911 2.05109 2.72727 2.25 2.72727H3V3.40909C3 3.58992 3.07902 3.76334 3.21967 3.89121C3.36032 4.01907 3.55109 4.09091 3.75 4.09091C3.94891 4.09091 4.13968 4.01907 4.28033 3.89121C4.42098 3.76334 4.5 3.58992 4.5 3.40909V2.72727H10.5V3.40909C10.5 3.58992 10.579 3.76334 10.7197 3.89121C10.8603 4.01907 11.0511 4.09091 11.25 4.09091C11.4489 4.09091 11.6397 4.01907 11.7803 3.89121C11.921 3.76334 12 3.58992 12 3.40909V2.72727H12.75C12.9489 2.72727 13.1397 2.79911 13.2803 2.92697C13.421 3.05484 13.5 3.22826 13.5 3.40909V5.45455ZM3.75 9.54545C3.89834 9.54545 4.04334 9.50547 4.16668 9.43055C4.29001 9.35563 4.38614 9.24914 4.44291 9.12456C4.49968 8.99997 4.51453 8.86288 4.48559 8.73062C4.45665 8.59836 4.38522 8.47687 4.28033 8.38152C4.17544 8.28616 4.0418 8.22123 3.89632 8.19492C3.75083 8.16861 3.60003 8.18211 3.46299 8.23372C3.32594 8.28532 3.20881 8.37271 3.1264 8.48484C3.04399 8.59696 3 8.72879 3 8.86364C3 9.04447 3.07902 9.21789 3.21967 9.34575C3.36032 9.47362 3.55109 9.54545 3.75 9.54545ZM3.75 12.2727C3.89834 12.2727 4.04334 12.2327 4.16668 12.1578C4.29001 12.0829 4.38614 11.9764 4.44291 11.8518C4.49968 11.7272 4.51453 11.5902 4.48559 11.4579C4.45665 11.3256 4.38522 11.2041 4.28033 11.1088C4.17544 11.0134 4.0418 10.9485 3.89632 10.9222C3.75083 10.8959 3.60003 10.9094 3.46299 10.961C3.32594 11.0126 3.20881 11.1 3.1264 11.2121C3.04399 11.3242 3 11.4561 3 11.5909C3 11.7717 3.07902 11.9452 3.21967 12.073C3.36032 12.2009 3.55109 12.2727 3.75 12.2727Z'
                              fill='#FFC20F'
                            />
                          </svg>
                          <div className='w-100-40px'>
                            {moment(data?.scheduledVisitDateTime)
                              .locale(rtl ? 'ar-SA' : 'en-US')
                              .format('MM/DD/YYYY')}{' '}
                            -{' '}
                            {moment(data.scheduledVisitDateTime)
                              .locale(rtl ? 'ar-SA' : 'en-US')
                              .format('hh:mm A')}
                          </div>
                        </li>
                        <li className='list-group-item d-flex px-0 py-3'>
                          <svg
                            width='24'
                            height='22'
                            viewBox='0 0 24 22'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                            className='w-40px'
                          >
                            <path
                              d='M20 8.86416V8.70832C20.0061 7.14902 19.4664 5.62905 18.4602 4.37177C17.454 3.11449 16.0344 2.1862 14.41 1.72332H14.35C13.511 1.48887 12.6369 1.3775 11.76 1.39332C9.67183 1.49837 7.7061 2.32993 6.264 3.71829C4.8219 5.10665 4.01215 6.94715 4 8.86416C3.41401 9.05312 2.90646 9.40417 2.54742 9.86884C2.18838 10.3335 1.99554 10.8889 1.99554 11.4583C1.99554 12.0277 2.18838 12.5831 2.54742 13.0478C2.90646 13.5125 3.41401 13.8635 4 14.0525C4.20597 15.8627 5.13892 17.538 6.61748 18.7528C8.09604 19.9675 10.0145 20.6348 12 20.625H12.23C14.15 20.5398 15.9749 19.8338 17.3809 18.6322C18.7868 17.4307 19.6829 15.8113 19.91 14.0617C20.5029 13.8834 21.0204 13.5401 21.3904 13.0796C21.7605 12.619 21.9647 12.0642 21.9746 11.4923C21.9845 10.9204 21.7996 10.3599 21.4457 9.88883C21.0918 9.41777 20.5864 9.05959 20 8.86416ZM12.18 18.7917C10.7324 18.83 9.3185 18.3872 8.19921 17.5448C7.07991 16.7024 6.33077 15.5174 6.09 14.2083H17.86C17.6159 15.4476 16.922 16.5748 15.8908 17.4068C14.8597 18.2389 13.5519 18.7269 12.18 18.7917ZM19 12.375H5C4.73479 12.375 4.48043 12.2784 4.2929 12.1065C4.10536 11.9346 4 11.7014 4 11.4583C4 11.2152 4.10536 10.9821 4.2929 10.8101C4.48043 10.6382 4.73479 10.5417 5 10.5417H7C7.26522 10.5417 7.51957 10.4451 7.70711 10.2732C7.89465 10.1013 8 9.8681 8 9.62499C8 9.38187 7.89465 9.14872 7.70711 8.97681C7.51957 8.8049 7.26522 8.70832 7 8.70832H6C6.04477 7.75738 6.34127 6.83071 6.86392 6.00825C7.38658 5.1858 8.11969 4.49226 9 3.98749V6.87499C9 7.11811 9.10536 7.35126 9.2929 7.52317C9.48043 7.69508 9.73479 7.79166 10 7.79166C10.2652 7.79166 10.5196 7.69508 10.7071 7.52317C10.8946 7.35126 11 7.11811 11 6.87499V3.29082C11.2714 3.24925 11.5452 3.22171 11.82 3.20832H12C12.3351 3.21265 12.6694 3.24023 13 3.29082V6.87499C13 7.11811 13.1054 7.35126 13.2929 7.52317C13.4804 7.69508 13.7348 7.79166 14 7.79166C14.2652 7.79166 14.5196 7.69508 14.7071 7.52317C14.8946 7.35126 15 7.11811 15 6.87499V3.95999C15.4242 4.18515 15.8199 4.4526 16.18 4.75749C16.7566 5.27073 17.2148 5.88492 17.5274 6.5636C17.84 7.24228 18.0008 7.97162 18 8.70832H17C16.7348 8.70832 16.4804 8.8049 16.2929 8.97681C16.1054 9.14872 16 9.38187 16 9.62499C16 9.8681 16.1054 10.1013 16.2929 10.2732C16.4804 10.4451 16.7348 10.5417 17 10.5417H19C19.2652 10.5417 19.5196 10.6382 19.7071 10.8101C19.8946 10.9821 20 11.2152 20 11.4583C20 11.7014 19.8946 11.9346 19.7071 12.1065C19.5196 12.2784 19.2652 12.375 19 12.375Z'
                              fill='#FFC20F'
                            />
                          </svg>

                          <div className='w-100-40px'>{rtl ? data.spNameAr : data.spNameEn}</div>
                        </li>
                      </ul>
                    </div>
                  </Col>
                  {/* Initial invoice */}
                  <Col sm={12} xl={7} className='mb-5'>
                    <InvoiceDetail data={data} rtl={rtl} />
                  </Col>
                  {/* Customer details */}
                  <Col sm={12} xl={5} className='mb-5'>
                    <div className='border rounded p-5 mh-200'>
                      <div className='d-flex align-items-center mb-3'>
                        <h4 className='text-gray-800 m-0'>
                          {t('VIEW_TICKET_MODAL.CUSTOMER_DETAILS')}
                          {!!data?.customerId && ` (#${formatShortCustomerId(data.customerId)})`}
                        </h4>
                      </div>

                      <ul className='list-group list-group-flush'>
                        <li className='list-group-item d-flex px-0 py-3'>
                          <svg
                            width='19'
                            height='17'
                            viewBox='0 0 19 17'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                            className='w-40px'
                          >
                            <path
                              d='M12.3827 9.10292C13.2706 8.44766 13.9187 7.5491 14.2368 6.53226C14.5549 5.51541 14.5272 4.43084 14.1576 3.42944C13.788 2.42804 13.0948 1.55961 12.1745 0.944954C11.2542 0.330302 10.1525 0 9.02272 0C7.89296 0 6.79129 0.330302 5.87098 0.944954C4.95067 1.55961 4.25748 2.42804 3.88785 3.42944C3.51823 4.43084 3.49054 5.51541 3.80865 6.53226C4.12676 7.5491 4.77485 8.44766 5.66274 9.10292C4.14131 9.67468 2.81381 10.623 1.82177 11.8468C0.829716 13.0705 0.210307 14.5239 0.0295717 16.0519C0.0164891 16.1635 0.0269602 16.2764 0.0603869 16.3841C0.0938137 16.4919 0.149541 16.5924 0.224388 16.68C0.375549 16.8568 0.59541 16.9701 0.835604 16.9949C1.0758 17.0197 1.31665 16.9539 1.50518 16.8121C1.6937 16.6703 1.81446 16.4641 1.84088 16.2388C2.03975 14.5782 2.88391 13.0445 4.21208 11.9308C5.54026 10.817 7.25932 10.2014 9.04084 10.2014C10.8224 10.2014 12.5414 10.817 13.8696 11.9308C15.1978 13.0445 16.0419 14.5782 16.2408 16.2388C16.2654 16.4475 16.3716 16.6403 16.5388 16.78C16.7061 16.9196 16.9226 16.9961 17.1464 16.9949H17.2461C17.4835 16.9692 17.7005 16.8567 17.8497 16.6816C17.999 16.5066 18.0685 16.2833 18.043 16.0604C17.8615 14.5281 17.2387 13.071 16.2416 11.8453C15.2444 10.6197 13.9105 9.67165 12.3827 9.10292ZM9.02272 8.49977C8.30624 8.49977 7.60584 8.30048 7.0101 7.9271C6.41437 7.55372 5.95005 7.02302 5.67586 6.4021C5.40167 5.78119 5.32993 5.09796 5.46971 4.43881C5.60949 3.77965 5.95451 3.17418 6.46114 2.69895C6.96778 2.22373 7.61327 1.9001 8.31599 1.76898C9.01871 1.63787 9.74709 1.70516 10.409 1.96235C11.071 2.21954 11.6368 2.65507 12.0348 3.21388C12.4329 3.77268 12.6453 4.42966 12.6453 5.10173C12.6453 6.00295 12.2637 6.86725 11.5843 7.50451C10.9049 8.14176 9.9835 8.49977 9.02272 8.49977Z'
                              fill='#00AB9A'
                            />
                          </svg>
                          <div className='w-100-40px'>
                            {data?.customerName
                              ? data?.customerName
                              : t('VIEW_TICKET_MODAL.NO_NAME')}
                          </div>
                        </li>
                        <li className='list-group-item d-flex px-0 py-3'>
                          <svg
                            width='20'
                            height='15'
                            viewBox='0 0 20 15'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                            className='w-40px'
                          >
                            <path
                              d='M16.743 8.27389C16.5323 8.27389 16.3121 8.22104 16.1014 8.1833C15.6747 8.10919 15.2555 8.01079 14.8469 7.88889C14.4026 7.76149 13.9142 7.7681 13.4758 7.90746C13.0373 8.04683 12.6798 8.30909 12.4719 8.64378L12.2612 8.98349C11.3284 8.57447 10.4713 8.06646 9.71382 7.4737C8.96184 6.87659 8.31739 6.20094 7.79851 5.46568L8.20073 5.25431C8.62532 5.09043 8.95802 4.80856 9.13482 4.46294C9.31161 4.11732 9.32001 3.73237 9.15838 3.38217C9.00633 3.05939 8.88156 2.72903 8.7849 2.39326C8.73701 2.22718 8.69871 2.05355 8.66998 1.87993C8.55368 1.34819 8.20037 0.866664 7.67365 0.522052C7.14694 0.177441 6.48144 -0.00760469 5.79701 0.00023953H2.92405C2.51133 -0.00281518 2.10262 0.0642647 1.72574 0.196913C1.34887 0.32956 1.01267 0.524662 0.740049 0.768935C0.467424 1.01321 0.264769 1.30092 0.14588 1.61248C0.0269902 1.92404 -0.00534231 2.25213 0.0510833 2.57443C0.561263 5.73697 2.39353 8.6754 5.25848 10.9256C8.12342 13.1757 11.8577 14.6093 15.8715 15H16.2355C16.9416 15.0008 17.6235 14.7966 18.1508 14.4263C18.4537 14.2127 18.6957 13.9508 18.8608 13.658C19.0259 13.3652 19.1103 13.0482 19.1084 12.7278V10.4631C19.0967 9.93872 18.8545 9.43382 18.4231 9.03457C17.9917 8.63531 17.3979 8.36646 16.743 8.27389ZM17.2218 12.8033C17.2217 12.9104 17.1925 13.0164 17.1364 13.114C17.0803 13.2116 16.9984 13.2987 16.8962 13.3694C16.7895 13.4427 16.6645 13.4973 16.5291 13.5298C16.3938 13.5624 16.2513 13.572 16.111 13.5581C12.5244 13.1957 9.19308 11.9023 6.64235 9.88203C4.09162 7.86178 2.46668 5.22965 2.02385 2.4008C2.00861 2.29023 2.02197 2.17836 2.06312 2.07197C2.10427 1.96557 2.17236 1.86686 2.26327 1.78179C2.35301 1.70127 2.46347 1.63673 2.58732 1.59248C2.71116 1.54822 2.84553 1.52526 2.98151 1.52513H5.85447C6.07717 1.52122 6.29463 1.57863 6.46942 1.68748C6.64422 1.79633 6.7654 1.94981 6.81213 2.12149C6.85043 2.32783 6.89832 2.53165 6.95577 2.73296C7.0664 3.1309 7.21363 3.52196 7.3963 3.90304L6.05558 4.39373C5.94095 4.43519 5.83783 4.49409 5.75215 4.56705C5.66648 4.64001 5.59993 4.72559 5.55633 4.81888C5.51272 4.91217 5.49293 5.01133 5.49808 5.11067C5.50323 5.21 5.53322 5.30756 5.58633 5.39774C6.96459 7.72489 9.3377 9.59556 12.2899 10.682C12.5231 10.7575 12.7846 10.7575 13.0177 10.682C13.1372 10.6483 13.2469 10.5963 13.3406 10.5289C13.4343 10.4615 13.5101 10.3801 13.5636 10.2895L14.1573 9.2326C14.6524 9.37216 15.1577 9.48812 15.6704 9.57985C15.9258 9.62515 16.1844 9.66289 16.4461 9.69309C16.6639 9.72992 16.8586 9.82545 16.9967 9.96323C17.1348 10.101 17.2076 10.2724 17.2027 10.448L17.2218 12.8033Z'
                              fill='#E86E6F'
                            />
                          </svg>
                          <div className='w-100-40px'>{data?.customerPhoneNumber ? data?.customerPhoneNumber : '**********'}</div>
                        </li>
                        {data?.backupNumber && (
                          <li className='list-group-item d-flex px-0 py-3'>
                            <svg
                              width='40'
                              height='20'
                              viewBox='0 0 11 16'
                              fill='#8af542'
                              xmlns='http://www.w3.org/2000/svg'
                            >
                              <path
                                d='M5.96609 11.3034L5.85359 11.2134C5.81179 11.1851 5.76639 11.1624 5.71859 11.1459L5.58359 11.0859C5.46196 11.0605 5.33592 11.0657 5.21679 11.101C5.09766 11.1364 4.98918 11.2008 4.90109 11.2884C4.83485 11.3613 4.78158 11.445 4.74359 11.5359C4.68684 11.6726 4.67177 11.823 4.70029 11.9682C4.72881 12.1134 4.79964 12.2469 4.90387 12.3519C5.0081 12.4569 5.14107 12.5288 5.28604 12.5584C5.43101 12.5881 5.58151 12.5741 5.71859 12.5184C5.80822 12.475 5.89148 12.4194 5.96609 12.3534C6.07016 12.248 6.14066 12.114 6.16869 11.9685C6.19672 11.8231 6.18103 11.6725 6.12359 11.5359C6.0862 11.4492 6.03276 11.3703 5.96609 11.3034ZM8.43359 0.585938H2.43359C1.83686 0.585938 1.26456 0.82299 0.842604 1.24495C0.420647 1.6669 0.183594 2.2392 0.183594 2.83594V13.3359C0.183594 13.9327 0.420647 14.505 0.842604 14.9269C1.26456 15.3489 1.83686 15.5859 2.43359 15.5859H8.43359C9.03033 15.5859 9.60263 15.3489 10.0246 14.9269C10.4465 14.505 10.6836 13.9327 10.6836 13.3359V2.83594C10.6836 2.2392 10.4465 1.6669 10.0246 1.24495C9.60263 0.82299 9.03033 0.585938 8.43359 0.585938ZM9.18359 13.3359C9.18359 13.5349 9.10458 13.7256 8.96392 13.8663C8.82327 14.0069 8.63251 14.0859 8.43359 14.0859H2.43359C2.23468 14.0859 2.04392 14.0069 1.90326 13.8663C1.76261 13.7256 1.68359 13.5349 1.68359 13.3359V2.83594C1.68359 2.63703 1.76261 2.44626 1.90326 2.30561C2.04392 2.16496 2.23468 2.08594 2.43359 2.08594H8.43359C8.63251 2.08594 8.82327 2.16496 8.96392 2.30561C9.10458 2.44626 9.18359 2.63703 9.18359 2.83594V13.3359Z'
                                fill='#66c427'
                              ></path>
                            </svg>
                            <div className='w-100-40px'>{data.backupNumber}</div>
                          </li>
                        )}
                        {data?.customerComments && (
                          <li className='list-group-item d-flex px-0 py-3'>
                            <div className='w-100-40px ml-3r'>{data?.customerComments}</div>
                          </li>
                        )}
                        {dataCustomerTags && dataCustomerTags.length > 0 && (
                          <li className='list-group-item d-flex px-0 py-3'>
                            <div className='mh-125px scroll'>
                              {dataCustomerTags?.map((item: TagsModel) => (
                                <div className='badge customer-tags ms-1 mb-1'>{item.tag}</div>
                              ))}
                            </div>
                          </li>
                        )}
                      </ul>
                    </div>
                  </Col>
                  {/* Map */}
                  <Col sm={12} xl={7} className='mb-5'>
                    <MapMaker
                      lat={data.customerLat}
                      lng={data.customerLng}
                    />
                  </Col>
                </Row>
              </Col>
              {/* Visit Timeline */}
              <Col sm={12} lg={4}>
                <div className='border rounded p-5 mb-5 grow'>
                  <h4 className='text-gray-800'>{t('VIEW_TICKET_MODAL.VISIT_TIMELINE')}</h4>
                  {timeLineData.length > 0 && <TicketTimeLine data={timeLineData} rtl={rtl} />}
                </div>
                {(data.ticketType !== TicketType.SUBSCRIPTION && data.ticketType !== TicketType.OFFER && !JSON.parse(data?.shoppingCartJson || '{}') && data.sourceType !== TicketSource.B8AK) && <div className='pt-3'>
                <div className='mb-2 mt-4'>{t('VIEW_PACKAGE_MODAL.TITLE_NOTE_ORDER')}</div>
                  <Form.Control
                    as="textarea"
                    placeholder={t('VIEW_PACKAGE_MODAL.NOTES')}
                    style={{ height: '100px' }}
                    value={dataComments}
                    className="py-4"
                    onChange={(event) => setDataComments(event.target.value)}
                    disabled={true}
                  />
                </div>} 
              </Col>
            </Row>
          )}
        </Modal.Body>
        <Modal.Footer className='justify-content-between modal-footer-gray'>
          <div>
            <Button variant='light' className='px-10 fw-normal h-50px' onClick={() => onHide?.()}>
              {t('CLOSE')}
            </Button>
          </div>
          <div className='d-flex flex-wrap'>
            {(!data.isInMarket && !data.status.startsWith(TicketStatus.Completed)) && (
              <>
                {(attendanceDelivery.isShow) &&
                  <Dropdown className="d-inline attendance-delivery-action h-50px mx-2">
                    <Dropdown.Toggle id="dropdown-autoclose-true" className='h-50px' variant="warning" disabled={isLoadingUpdateAttendanceDelivery || isDisputedTicket}>
                    {isLoadingUpdateAttendanceDelivery && <span className='spinner-border spinner-border-sm align-middle me-2'></span>}{t('VIEW_TICKET_MODAL.ATTENDANCE_DELIVERY.ACTION')}
                    </Dropdown.Toggle>
                    <Dropdown.Menu className=''>
                      <b className='ms-5'>{t('VIEW_TICKET_MODAL.ATTENDANCE_DELIVERY.ATTENDANCE_GROUP')}</b>
                      <Dropdown.Item as={'button'} className={classNameFunc([['Attendant', 'Delivered', 'UndeliveredCustomerNotReachable', 'UndeliveredNoFemale', 'UndeliveredOther'].includes(attendanceDelivery?.statusSelected || "") && 'selected', 'item-actions attendance'])}
                        disabled={(attendanceDelivery.statusSelected !== undefined && !['Attendant', 'Unattendant'].some(e => e === attendanceDelivery.statusSelected))
                        || attendanceDelivery.statusSelected === 'Attendant'}
                        onClick={() => onChangeStatusAttendanceDelivery('attendance', data as any, 'Attendant')}
                      >
                        <div className='d-flex align-items-center mx-5 px-4 item-content'>
                          <svg width="14" height="14" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.59375 2.53125L3.65625 6.46875L1.6875 4.5" strokeWidth={1.5} stroke="#00171F" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                          <span className='ms-1'>{t('VIEW_TICKET_MODAL.ATTENDANCE_DELIVERY.ATTENDANT')}</span>
                        </div>
                      </Dropdown.Item>
                      <Dropdown.Item as={'button'} className={classNameFunc([attendanceDelivery.statusSelected === 'Unattendant' && 'selected', 'item-actions unattendance'])}
                        disabled={(attendanceDelivery.statusSelected !== undefined && !['Attendant', 'Unattendant'].some(e => e === attendanceDelivery.statusSelected))
                        || attendanceDelivery.statusSelected === 'Unattendant'}
                        onClick={() => onChangeStatusAttendanceDelivery('attendance', data as any, 'Unattendant')}
                      >
                        <div className='d-flex align-items-center mx-5 px-4 item-content'>
                          <svg width="14" height="14" viewBox="0 0 7 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.08186 1.32617L1.70312 4.73633" stroke="#00171F" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M5.08186 4.73633L1.70312 1.32617" stroke="#00171F" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                          <span className='ms-1'>{t('VIEW_TICKET_MODAL.ATTENDANCE_DELIVERY.UN_ATTENDANT')}</span>
                        </div>
                      </Dropdown.Item>
                      <hr className='my-3' />
                      <b className='ms-5'>{t('VIEW_TICKET_MODAL.ATTENDANCE_DELIVERY.DELIVERY_GROUP')}</b>
                      <Dropdown.Item as={'button'} className={classNameFunc([attendanceDelivery.statusSelected === 'Delivered' && 'selected', 'item-actions delivery'])}
                        disabled={[undefined, 'Unattendant'].some(e => e === attendanceDelivery.statusSelected) || attendanceDelivery.statusSelected === 'Delivered'}
                        onClick={() => onChangeStatusAttendanceDelivery('delivery', data as any, 'Delivered')}
                      >
                        <div className='d-flex align-items-center mx-5 px-4 item-content'>
                          <svg width="14" height="14" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.59375 2.53125L3.65625 6.46875L1.6875 4.5" strokeWidth={1.5} stroke="#00171F" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                          <span className='ms-1'>{t('VIEW_TICKET_MODAL.ATTENDANCE_DELIVERY.DELIVERED')}</span>
                        </div>
                      </Dropdown.Item>
                      <Dropdown.Item as={'button'} className={classNameFunc([attendanceDelivery.statusSelected === 'UndeliveredCustomerNotReachable' && 'selected', 'item-actions undelivery '])}
                        disabled={[undefined, 'Unattendant'].some(e => e === attendanceDelivery.statusSelected) || attendanceDelivery.statusSelected === 'UndeliveredCustomerNotReachable'}
                        onClick={() => onChangeStatusAttendanceDelivery('delivery', data as any, 'UndeliveredCustomerNotReachable')}
                      >
                        <div className='d-flex align-items-center mx-5 px-4 item-content'>
                          <svg width="14" height="14" viewBox="0 0 7 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.08186 1.32617L1.70312 4.73633" stroke="#00171F" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M5.08186 4.73633L1.70312 1.32617" stroke="#00171F" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                          <span className='ms-1'>{t('VIEW_TICKET_MODAL.ATTENDANCE_DELIVERY.UNDELIVERED_CUSTOMER')}</span>
                        </div>
                      </Dropdown.Item>
                      <Dropdown.Item as={'button'} className={classNameFunc([attendanceDelivery.statusSelected === 'UndeliveredNoFemale' && 'selected', 'item-actions undelivery'])}
                        disabled={[undefined, 'Unattendant'].some(e => e === attendanceDelivery.statusSelected) || attendanceDelivery.statusSelected === 'UndeliveredNoFemale'}
                        onClick={() => onChangeStatusAttendanceDelivery('delivery', data as any, 'UndeliveredNoFemale')}
                      >
                        <div className='d-flex align-items-center mx-5 px-4 item-content'>
                          <svg width="14" height="14" viewBox="0 0 7 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.08186 1.32617L1.70312 4.73633" stroke="#00171F" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M5.08186 4.73633L1.70312 1.32617" stroke="#00171F" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                          <span className='ms-1'>{t('VIEW_TICKET_MODAL.ATTENDANCE_DELIVERY.UNDELIVERED_NO')}</span>
                        </div>
                      </Dropdown.Item>
                      <Dropdown.Item as={'button'} className={classNameFunc([attendanceDelivery.statusSelected === 'UndeliveredOther' && 'selected', 'item-actions undelivery'])}
                        disabled={[undefined, 'Unattendant'].some(e => e === attendanceDelivery.statusSelected) || attendanceDelivery.statusSelected === 'UndeliveredOther'}
                        onClick={() => onChangeStatusAttendanceDelivery('delivery', data as any, 'UndeliveredOther')}
                      >
                        <div className='d-flex align-items-center mx-5 px-4 item-content'>
                          <svg width="14" height="14" viewBox="0 0 7 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.08186 1.32617L1.70312 4.73633" stroke="#00171F" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M5.08186 4.73633L1.70312 1.32617" stroke="#00171F" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                          <span className='ms-1'>{t('VIEW_TICKET_MODAL.ATTENDANCE_DELIVERY.UNDELIVERED_OTHER')}</span>
                        </div>
                      </Dropdown.Item>
                      {attendanceDelivery.isShowUndo && <>
                        <hr className='my-3' />
                        <Dropdown.Item as={'button'} className={classNameFunc(['item-actions undo-delivery'])}>
                          <div className='d-flex align-items-center mx-5 px-4 item-content'>
                            <svg width="14" height="14" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M3.99991 0.5C4.22179 0.5 4.42647 0.617187 4.53897 0.809375L7.91397 6.55937C8.02804 6.75312 8.02804 6.99219 7.9171 7.18594C7.80616 7.37969 7.59835 7.5 7.37491 7.5H0.624911C0.401474 7.5 0.193662 7.37969 0.0827241 7.18594C-0.0282134 6.99219 -0.0266509 6.75156 0.0858491 6.55937L3.46085 0.809375C3.57335 0.617187 3.77804 0.5 3.99991 0.5ZM3.99991 2.5C3.7921 2.5 3.62491 2.66719 3.62491 2.875V4.625C3.62491 4.83281 3.7921 5 3.99991 5C4.20772 5 4.37491 4.83281 4.37491 4.625V2.875C4.37491 2.66719 4.20772 2.5 3.99991 2.5ZM4.49991 6C4.49991 5.72344 4.27647 5.5 3.99991 5.5C3.72335 5.5 3.49991 5.72344 3.49991 6C3.49991 6.27656 3.72335 6.5 3.99991 6.5C4.27647 6.5 4.49991 6.27656 4.49991 6Z"
                                fill="#FFC20F" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <span className='ms-1'>{t('VIEW_TICKET_MODAL.ATTENDANCE_DELIVERY.UNDO_ACTION')}</span>
                          </div>
                        </Dropdown.Item>
                      </>}
                    </Dropdown.Menu>
                  </Dropdown>}
                {(data.status.startsWith(TicketStatus.Inprogress) ||
                  data.status.startsWith(TicketStatus.ToBeAssigned)) &&
                  data.ticketType !== TicketType.SUBSCRIPTION &&
                  !data.packageId && (
                    <Button
                      variant='danger'
                      className='px-10 fw-normal mb-3 h-50px'
                      onClick={() => onDispute?.(data.id)}
                    >
                      {t('VIEW_TICKET_MODAL.DISPUTE')}
                    </Button>
                  )}
                {data.status.startsWith(TicketStatus.Inprogress) &&
                  data.ticketType !== TicketType.SUBSCRIPTION && (
                    <Button
                      variant='warning'
                      className='px-10 fw-normal  mb-3 mx-2 h-50px'
                      onClick={() => onReassign?.(data)}
                    >
                      {t('VIEW_TICKET_MODAL.REASSIGN')}
                    </Button>
                  )}
                {data.status.startsWith(TicketStatus.Inprogress) &&
                  data.ticketType !== TicketType.SUBSCRIPTION &&
                  !data.packageId && (
                    <Button
                      variant='success'
                      className='px-10 fw-normal  mb-3 h-50px'
                      onClick={() => onComplete?.(data)}
                    >
                      {t('VIEW_TICKET_MODAL.COMPLETE')}
                    </Button>
                  )}
              </>
            )}
            {(data.status.startsWith(TicketStatus.Completed) ||
              data.ticketType === TicketType.SUBSCRIPTION ||
              data.packageId)
              && menuConfig['INVOICE'] != SideMenuStatus.HIDE
              && (
                <Button variant='info' className='px-10 fw-normal h-50px' onClick={handleViewInvoice} disabled={menuConfig['INVOICE'] == SideMenuStatus.DISABLE}>
                  {t('INVOICE')}
                </Button>
              )}
            {data.status.startsWith(TicketStatus.Completed) && (
              <Button
                variant='warning'
                className='px-10 fw-normal  mb-3 mx-2 h-50px'
                onClick={() => onWarranty?.(data)}
              >
                {t('VIEW_TICKET_MODAL.OPEN_WARRANTY')}
              </Button>
            )}
          </div>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export { ViewTicketModal }
